import { useEffect, useRef, type MutableRefObject } from 'react';

import { useState$ } from '@/js/libs/observable/index.ts';

const THRESHOLD = 100;

export const useDirection = (isScrollingRef: MutableRefObject<boolean>) => {
  const [direction$, setDirection] = useState$<'up' | 'down' | null>(null);
  const lastScrollY = useRef<number>(0);
  const accumulatedDelta = useRef<number>(0);

  useEffect(() => {
    lastScrollY.current = window.scrollY;

    const handleScroll = () => {
      if (isScrollingRef.current) {
        lastScrollY.current = window.scrollY;
        return;
      }

      const currentScrollY = window.scrollY;
      const delta = currentScrollY - lastScrollY.current;

      accumulatedDelta.current += delta;

      if (Math.abs(accumulatedDelta.current) >= THRESHOLD) {
        const newDirection = accumulatedDelta.current > 0 ? 'down' : 'up';
        setDirection(newDirection);
        accumulatedDelta.current = 0;
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isScrollingRef, setDirection]);

  return direction$;
};
